export default __webpack_public_path__ + "static/media/blog-6.2a272193.jpg";